export default __webpack_public_path__ + "static/media/Tanvi.29b39477.jpg";